import { Modal } from '../../../components';
import { BUTTON_CONSTANTS, MARKETPLACE_LISTING_CONSTANTS } from '../../../constants/common';
import './deactivateListingModal.scss';

export type DeactivateListingModalProps = {
  isOpen: boolean;
  name: string;
  width?: number;
  onClose: () => void;
  onConfirm: () => void;
};

const DeactivateListingModal = ({ isOpen, name, width = 500, onClose, onConfirm }: DeactivateListingModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} width={width} ignoreBackdrop>
      <div className="deactivate-listing-modal">
        <div className="header">
          <h4>{MARKETPLACE_LISTING_CONSTANTS.DEACTIVATE_LISTING}</h4>
          <hr />
        </div>
        <div className="body">
          <p>
            Are you sure you want to deactivate &quot;{name}&quot;? This listing will no longer be visible to potential buyers and
            will be moved to your inactive listings.
          </p>
        </div>
        <div className="footer">
          <button className="button medium green inverted" onClick={onClose}>
            {BUTTON_CONSTANTS.CANCEL}
          </button>
          <button className="button medium red inverted" onClick={onConfirm}>
            {BUTTON_CONSTANTS.DEACTIVATE}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeactivateListingModal;
